@if (warehouses().length > 0) {
  <section class="flex flex-col gap-3">
    <h4 class="font-semibold">{{ 'Client_PO_AvailableInventory_Title' | translateWF: 'Available inventory' }} — {{ itemCode() }}</h4>

    <p-table [value]="rows()" [loading]="isLoading() > 0">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'Client_PO_AvailableInventory_Warehouse' | translateWF: 'Warehouse' }}</th>
          <th class="text-center">{{ 'Client_PO_AvailableInventory_Lot' | translateWF: 'Lot' }}</th>
          <th class="text-center">{{ 'Client_PO_AvailableInventory_Manufacturer' | translateWF: 'Manufacturer' }}</th>
          <th class="text-center">{{ 'Client_PO_AvailableInventory_LotItems' | translateWF: 'Lot Items' }}</th>
          <th class="text-center">
            {{ 'Client_PO_AvailableInventory_NetQuantity' | translateWF: 'Net Quantity' }}
            @if (uomLabel()) {
              ({{ uomLabel() }})
            }
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.warehouse.labelKey | translateWF: row.warehouse.fallbackLabel }}</td>
          <td class="text-center font-semibold">{{ row.manufacturerLotNumber || '—' }}</td>
          <td class="text-center">{{ row.manufacturer?.name || '—' }}</td>
          <td class="text-center">{{ row.lotItemCount | number }}</td>
          <td class="text-center">{{ row.totalNetQuantity | number: '1.0-2' }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer">
        @if (rows().length > 0) {
          @if (warehouses().length > 1) {
            @for (subtotal of warehouseSubtotals(); track subtotal.warehouse.locationCode) {
              <tr>
                <td colspan="3" class="text-right">
                  {{ 'Client_PO_AvailableInventory_Subtotal' | translateWF: 'Subtotal' }}
                  {{ subtotal.warehouse.labelKey | translateWF: subtotal.warehouse.fallbackLabel }}:
                </td>
                <td class="text-center">{{ subtotal.lotItemCount | number }}</td>
                <td class="text-center">{{ subtotal.totalNetQuantity | number: '1.0-2' }}</td>
              </tr>
            }
          }
          <tr class="font-bold">
            <td colspan="3" class="text-right">{{ 'Client_PO_AvailableInventory_Total' | translateWF: 'Total' }}:</td>
            <td class="text-center">{{ totalLotItems() | number }}</td>
            <td class="text-center">{{ totalNetQuantity() | number: '1.0-2' }}</td>
          </tr>
        }
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" class="text-center">
            {{ 'Client_PO_AvailableInventory_Empty' | translateWF: 'No available inventory for this item' }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </section>
}
